import React from 'react';
import { BaseLayoutFactory } from '../global/base-layout-factory';
import { AuditsProvider } from './context/audits-context';
import { AuditDetailComponent } from './audit-detail-component';

export function AuditDetailFactory() {
    return (
        <BaseLayoutFactory>
            <AuditsProvider>
                <AuditDetailComponent />
            </AuditsProvider>
        </BaseLayoutFactory>
    );
}
